import axios from "axios";

export const getGanttData = async (companyKey) => {
    const response = await axios.get("api/gantt/getGanttData/"+companyKey);
    const ganttData = response.data;
    return ganttData;
}

export const getGanttDataMachine = async (machineId) => {
    const response = await axios.get("api/gantt/getGanttDataMachine/"+machineId);
    const ganttData = response.data;
    return ganttData;
}




